<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("foodcategories") }}
      </div>
      <router-link class="btn-blue" to="/fnb/food-categories"
        >{{ $tc("foodcategories", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="fc_category"
                name="foodname"
                id="foodname"
                v-validate="'required'"
              />
              <label>{{ $tc("foodcategoryname", 2) }}</label>
            </div>
            <Tooltip :title="$t('rawmaterial_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('foodname')">{{
              errors.first("foodname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label>{{ $t("isparent") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="is_parent"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <div v-if="!is_parent" class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="fc_parent_label.length > 0 ? 'shift-up' : ''">{{
              $tc("parentfoodcategoryname", 2)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="fc_parent_label"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(fc, fcIndex) in ms_food_categories"
                  :key="fcIndex"
                  href="#"
                  :disabled="fc.fc_category == fc_category"
                  @click="
                    fc_parent_id = fc.fc_id;
                    fc_parent_label = fc.fc_category;
                  "
                  >{{ fc.fc_category }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && fc_parent_label == ''"
                >Please Select Parent Food Category.</span
              >
            </p>
          </div>
        </div>

        <div v-if="is_parent" class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                v-model="fc_order"
                name="foodorder"
                id="foodorder"
              />
              <label>{{ $tc("foodorder", 2) }}</label>
            </div>
            <Tooltip :title="$t('foodorder_tooltip')" />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-10 pr-0">
              <div class="d-flex align-items-center">
                <label for="file-selector" class="file-selector w-100">
                  <span class="text-truncate">{{ fc_icon_url }}</span>
                  <input
                    placeholder="Category icon"
                    v-on:change="uploadImage($event)"
                    type="file"
                    class="d-none"
                    name="file-selector"
                    id="file-selector"
                  />
                </label>

                <Tooltip
                  :title="
                    `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                  "
                />
              </div>
              <p class="error_message">
                <span
                  v-if="
                    (submitted && fc_icon_url.length == 0) ||
                      (submitted && !isIconUpdated)
                  "
                  >Please Select Food  Category Image.</span
                >
              </p>
            </div>
            <div class="col-2 pt-1">
              <img
                v-if="fc_icon_url && fc_icon_url.length > 0"
                :src="_GetImagePath(fc_icon_url)"
                @click="openImageModal(fc_icon_url, fc_icon_url)"
                height="35"
                width="35"
                class="rounded c-pointer"
              />
              <img
                v-else
                src="@/assets/img/icons/empty-image.svg"
                alt="Empty Image"
                height="35"
                width="35"
                class="rounded"
              />
            </div>
          </div>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label for="file-selector2" class="file-selector w-100">
              <span>{{fc_icon_active_url}}</span>
              <input
                v-on:change="uploadActiveImage($event)"
                type="file"
                class="d-none"
                name="file-selector2"
                id="file-selector2"
              />
            </label>

            <Tooltip :title="Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg" />
          </div>
          <p class="error_message">
            <span v-if="submitted && fc_icon_active_url.length == 0">Please Select Food Image.</span>
          </p>
        </div>-->

        <div class="col-md-2 mb-4">
          <div class="d-flex align-items-center">
            <label>{{ $t("active") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="fc_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
        <div class="col-lg-3 col-xl-1 align-self-center mb-4 px-0">
          <div class="col-lg-12 col-xl-12">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="color"
                  @change="setColor($event, 'font')"
                  v-model="fc_fontColor"
                />
                <label>Font Color</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-xl-1 align-self-center mb-4 px-0">
          <div class="col-lg-12 col-xl-12">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="color"
                  @change="setColor($event, 'background')"
                  v-model="fc_bgColor"
                />
                <label>Background Color</label>
              </div>
            </div>
          </div>
        </div>
        <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
          <div class="bn-tabs-nav">
            <button
              v-for="(fnbContent, fnbContentIndex) in FnbCategoryContent"
              :key="fnbContentIndex"
              :class="[
                'btn-tab-title ',
                { active: fnbContentIndex == activeClass }
              ]"
              @click.prevent.stop="onChangeTabHandler($event, fnbContentIndex)"
            >
              <strong>
                <span
                  :class="fnbContent.category_lang_name ? '' : 'text-danger'"
                  >{{ fnbContent.langauge }}</span
                >
              </strong>
            </button>
          </div>
          <div class="bn-tabs-content">
            <div
              v-for="(fnbContent, fnbContentIndex) in FnbCategoryContent"
              :key="fnbContentIndex"
            >
              <div v-if="fnbContentIndex === activeClass">
                <div class="row">
                  <div class="col-lg-6 col-xl-6 align-self-center">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="text"
                          v-model="fnbContent.category_lang_name"
                          name="fnbcategorynamelang"
                          id="fnbcategorynamelang"
                          v-validate="
                            fnbContent.langauge &&
                            fnbContent.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                          "
                        />
                        <label>{{ $t("foodcategory") }}</label>
                      </div>
                      <Tooltip :title="$t('foodcategory')" />
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && errors.has('fnbcategorynamelang')"
                        >{{ errors.first("fnbcategorynamelang") }}</span
                      >
                    </p>
                    <p
                      v-if="
                        fnbContent.langauge &&
                          fnbContent.langauge.toLowerCase() !== 'english'
                      "
                      class="fs-12"
                    >
                      (Optional)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">
            {{ $t("update") }}
          </button>
          <!-- <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/food-categories"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import MovieService from "@/services/MovieService";

export default {
  components: { Multiselect },
  data() {
    return {
      submitted: false,
      fc_category: "",
      fc_parent_id: 0,
      fc_order: "",
      fc_parent_label: "",
      fc_is_active: true,
      is_parent: false,
      fc_icon_url: "Category icon",
      isIconUpdated: true,
      fc_icon_active_url: "",
      fc_id: "",
      BaseURL: "",
      ms_food_categories: [],
      tempModalImagePath: "",
      tempModalImageName: "",
      ContentLanguages: [],
      FnbCategoryContent: [],
      activeClass: 0,
      fc_fontColor: "",
      fc_bgColor: ""
    };
  },
  beforeMount() {
    this.fc_id = this.$route.query.fc_id;
    this.GetCategoryDetails();
  },
  mounted() {
    // this.getVendorsList();
  },
  methods: {
    getMovieContentLangauge: function() {
      MovieService.GetMovieContentLanguages()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers();
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error On getMovieContentLangauge :", error);
        });
    },
    setColor(event, typeName) {
      if (typeName == "font") {
        this.fc_fontColor = event.target.value;
        console.log(this.fontColor, "fontColor");
      } else {
        this.fc_bgColor = event.target.value;
        console.log(this.bgColor, "bgColor");
      }
    },
    makeLangContainers: function() {
      this.ContentLanguages.map(x => {
        let Obj = {
          ...x,
          category_lang_name: ""
        };
        let fnbObjIndex = this.FnbCategoryContent.findIndex(
          y => y.content_lang_id == x.langaugeId
        );
        if (fnbObjIndex > -1) {
          this.FnbCategoryContent[fnbObjIndex] = {
            ...this.FnbCategoryContent[fnbObjIndex],
            ...x
          };
        } else {
          this.FnbCategoryContent.push(Obj);
        }
      });

      this.$forceUpdate();
    },
    GetCategoryDetails: function() {
      PosFnbService.GetSingleFoodCategory({
        fc_id: this.fc_id
      }).then(({ data }) => {
        if (data.status) {
          let fc_details = data.Record;

          this.fc_category = fc_details.fc_category;
          this.fc_parent_id = fc_details.fc_parent_id;
          this.fc_order = fc_details.fc_order;
          this.fc_icon_url = fc_details.fc_icon_url || this.fc_icon_url;
          this.fc_icon_active_url = fc_details.fc_icon_active_url;
          this.fc_is_active = fc_details.fc_is_active == true ? "Y" : "N";
          this.fc_fontColor = fc_details.fc_fontColor;
          this.fc_bgColor = fc_details.fc_bgColor;

          if (fc_details.fc_parent_id == 0) {
            this.is_parent = true;
          }

          this.FnbCategoryContent = fc_details.fnbCategoryContent || [];

          this.getVendorsList();
          this.getMovieContentLangauge();
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    onChangeTabHandler: function(event, index) {
      this.activeClass = index;
    },
    openImageModal: function(image_name, image_path) {
      this.tempModalImagePath = image_path;
      this.tempModalImageName = image_name;
      this.$refs["preview-modal"].show();
    },
    getVendorsList: function() {
      let payload = {
        tableName: "ms_food_categories"
        // fc_id: this.fc_id
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_food_categories = data.Records;
            this.ms_food_categories.map(x => {
              if (this.fc_id == x.fc_id) {
                // this.fc_category = x.fc_category;
                // this.fc_parent_id = x.fc_parent_id;
                // this.fc_order = x.fc_order;
                // this.fc_icon_url = x.fc_icon_url;
                // this.fc_icon_active_url = x.fc_icon_active_url;
                // this.fc_is_active = x.fc_is_active == true ? "Y" : "N";
                // if(x.fc_parent_id == 0) {
                // this.is_parent = true;
                // }
              }
              this.ms_food_categories.map(y => {
                if (this.fc_parent_id > 0 && this.fc_parent_id == y.fc_id) {
                  this.fc_parent_label = y.fc_category;
                }
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    uploadImage: function(image) {
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "Category Icon Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.isIconUpdated = true;
            self.fc_icon_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(error => {
          alert(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    },
    uploadActiveImage: function(image) {
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "Category Icon Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          data.message ? alert(data.message) : "";
          if (data.status) {
            self.fc_icon_active_url = data.path;
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(error => {
          alert(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    },
    onResetForm: function() {
      (this.fc_category = ""),
        (this.fc_parent_id = 0),
        (this.fc_parent_label = ""),
        (this.fc_order = ""),
        (this.is_parent = false),
        (this.fc_icon_url = "Category icon"),
        (this.isIconUpdated = false),
        (this.fc_icon_active_url = ""),
        (this.fc_is_active = true);
      this.fc_fontColor = "";
      this.fc_bgColor = "";
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      if (this.is_parent) {
        this.fc_parent_id = 0;
      }
      if (!this.is_parent && this.fc_parent_id == 0) {
        return this.$toasted.show("Please Select Parent category");
      }
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid && this.isIconUpdated) {
          let payload = {
            fc_category: this.fc_category,
            fc_parent_id: this.fc_parent_id,
            fc_order: this.fc_order,
            fc_is_active: this.fc_is_active,
            fc_icon_url: this.fc_icon_url,
            fc_icon_active_url: this.fc_icon_active_url,
            fc_id: this.fc_id,
            FnbCategoryContent: this.FnbCategoryContent,
            fc_fontColor: this.fc_fontColor,
            fc_bgColor: this.fc_bgColor
          };
          PosFnbService.UpdateFoodCategory(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                this.$router.push({
                  path: "/fnb/food-categories"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/editFoodCategories.vue